// extracted by mini-css-extract-plugin
export default {"main":"Home_main__19nnz","h2":"Home_h2__q0EGp","p":"Home_p__PgjFB"};